import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './animations.css';
import App from './App';

// Import console filter to reduce development noise
import './consoleFilter';

// Build cache bust
window.__buildTime = "2026-06-05T15:20:00";

const root = ReactDOM.createRoot(document.getElementById('root'));

// Disable StrictMode in production to prevent double-rendering
if (process.env.NODE_ENV === 'production') {
  root.render(<App />);
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
